// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-greenboard-src-templates-docs-jsx": () => import("./../node_modules/gatsby-greenboard/src/templates/docs.jsx" /* webpackChunkName: "component---node-modules-gatsby-greenboard-src-templates-docs-jsx" */)
}

